import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'app-contact-us-modal',
  templateUrl: './contact-us-modal.component.html',
  styleUrls: ['./contact-us-modal.component.scss']
})
export class ContactUsModalComponent implements OnInit {
  privacyHeader: any;
  privacyMessage: any;
  constructor(private dialogRef: MatDialogRef<ContactUsModalComponent>) {}

  ngOnInit() {
    this.privacyHeader = 'Contact Us';
  }

  close(confirm: boolean) {
    this.dialogRef.close({ status: confirm });
  }
}
